import React, { useContext, useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import AdvancedSearchDropdown from '../../../components/dropdown';

import { AdvancedSearchShipmentContext } from '../../context';
import { id } from '../../../../filters/options/carrier';
import { isOperator } from '../../../../filters/operators/collection';
import Global from '../../../../store/global-selectors';
import GetCarrierDisplayName from '../../../../components/data-driven-logo/get-carrier-display-name';

import messages from '../messages';

import baseStyle from '../../../style.module.less';

const defaultOption = {
  id: 'DEFAULT_OPTION',
  apiKey: 'DEFAULT_OPTION',
  component: messages.selectOne,
};

const CarrierFilter = () => {
  const carriers = useSelector(Global.selectReferenceDatagetSellerCarriers);
  const options = useMemo(() => {
    return carriers.map((carrier) => ({
      id: carrier.carrierId,
      apiKey: carrier.carrierId,
      component: GetCarrierDisplayName(carrier.carrierId),
    }));
  }, [carriers]);
  const intl = useIntl();
  const allOptions = useMemo(
    () =>
      [defaultOption, ...options].map((opt) =>
        typeof opt.component === 'string'
          ? opt
          : {
              ...opt,
              component: intl.formatMessage(opt.component, opt.component.values),
            },
      ),
    [options, intl],
  );

  const { filters, updateFilter, clearFilter } = useContext(AdvancedSearchShipmentContext);

  const { value: [value = defaultOption.apiKey] = [] } = filters.find((filter) => filter.id === id) || {};
  const selectedCarrier = allOptions.find((opt) => opt.apiKey === value);

  const onOptionSelected = useCallback(
    (option) => {
      if (option.id === defaultOption.id) {
        clearFilter(id);
        return;
      }
      updateFilter(id, [option.apiKey], isOperator);
    },
    [updateFilter, clearFilter],
  );

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.carrier} />
      </label>
      <AdvancedSearchDropdown onOptionSelected={onOptionSelected} options={allOptions} selectedId={selectedCarrier.id} />
    </span>
  );
};

export default CarrierFilter;
